import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Card, Col, Container, Row, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getDashboardTestCycleData } from '../../../modules/project';
import CustomAvatar from '../../elements/CustomAvatar';
import Label from '../../../ui/primitives/Label';

const TestCycleContent = ({ projects }) => {
  const [testCycleData, setTestCycleData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const fetchTestCycleData = async () => {
    setLoading(true);
    try {
      const response = await getDashboardTestCycleData(projects);
      setTestCycleData(response?.testcycle_data);
    } catch (error) {
      setError(error.message || 'Failed to fetch data');
    }
    setLoading(false);
  };

  useEffect(() => {
    if (projects && projects.length > 0) fetchTestCycleData();
  }, [projects]);
  
  return (
    <Container fluid>
      <Row>
        <Col>
          <h6 className="subheading-text">Executed in Last 24 Hours</h6>
        </Col>
      </Row>
      {loading ? (
        <Spinner style={{ display: 'block', margin: 'auto', color: 'var(--primary-color)' }} />
      ) : testCycleData && testCycleData.length === 0 ? (
        <Row>
          <Col className="text-center">
            <Card>
              <Card.Body>
                {error ? (
                  <Typography variant="body2" color="error">
                    {error}
                  </Typography>
                ) : (
                  <Typography variant="body2">
                    No test cycles have been executed in the last 24 hours.
                  </Typography>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ) : (
        <>
          {testCycleData &&
            testCycleData.map((testcycle) => (
              <Row
                key={testcycle.id}
                className="mt-2 cursor-pointer"
                onClick={() =>
                  navigate(
                    `/project/${testcycle?.project?.project_id}/testcycles/${testcycle.key}?type=executions`
                  )
                }>
                <Col>
                  <Card style={{ padding: '10px !important' }}>
                    <Card.Body className="card-body-list">
                      <Container fluid>
                        <Row className="d-flex justify-content-between align-items-center">
                          <Col md="8">
                            <Box className="d-flex align-items-center">
                              <Box
                                title={testcycle.type}
                                sx={{
                                  bgcolor: 'var(--primary-color)',
                                  width: '26px',
                                  height: '26px',
                                  borderRadius: '4px',
                                  color: 'white',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontWeight: 'bold',
                                }}>
                                {testcycle.type[0]}
                              </Box>
                              <Box className="ml-2" sx={{ marginLeft: '16px' }}>
                                <Typography variant="subtitle1">
                                  {testcycle.name}
                                </Typography>
                                <Typography
                                  variant="subtitle2"
                                  className="text-muted">
                                  {testcycle.key} {' - '}
                                  {testcycle?.project?.project_name}
                                </Typography>
                                <Typography
                                  variant="subtitle2"
                                  className="text-muted">
                                  {testcycle?.iteration_details?.name}
                                </Typography>
                              </Box>
                            </Box>
                          </Col>
                          <Col
                            md="2"
                            sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography
                              variant="subtitle2"
                              sx={{
                                border: '0.8px solid grey',
                                borderRadius: '4px',
                                padding: '4px 12px',
                                display: 'inline-block',
                              }}
                              className="text-muted">
                              {testcycle.purpose}
                            </Typography>
                          </Col>
                          <Col>
                            <Box className="d-flex align-items-center justify-content-around">
                              <Label
                                color={testcycle?.status_color}
                                name={testcycle?.status}
                              />
                              <CustomAvatar
                                firstName={
                                  testcycle.iteration_details?.owner_details
                                    ?.first_name
                                }
                                lastName={
                                  testcycle.iteration_details?.owner_details
                                    ?.last_name
                                }
                                size={36}
                              />
                            </Box>
                          </Col>
                        </Row>
                      </Container>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            ))}
        </>
      )}
    </Container>
  );
};

export default TestCycleContent;
